import React from "react";
import { useNavigate } from "react-router-dom";
import MainMenuItem from "app/components/MainMenuItem";
import Path from "app/route/Path";

function KitOrderHistoryMenuItem(props) {
  const navigate = useNavigate();

  const onMenuItemClicked = () => {
    navigate(Path.kit.order.history);
  };

  return (
    <MainMenuItem
      itemTitleString="発注履歴を見る"
      onClick={onMenuItemClicked}
      size="100%"
    />
  );
}

export default KitOrderHistoryMenuItem;
